import { api } from '../http';
import { IraSearchHistoryTypes } from '../types';

// pom-2-api /v1/ira-search-history (ClickUp 868mkwmk5). Responses are the
// usual PresenterFactory envelope: { result, isValid, message }.
type Envelope<T> = { result: T; isValid: boolean; message?: string };

// These endpoints answer 403 for feature-level refusals (setting off, no intake
// access). The screens show those as messages, so they must not trigger the
// global "permissions changed" redirect to the dashboard.
const OWN_403 = { skipPermissionsChanged: true } as const;

export const IraSearchHistoryService = {
    async listSearches(page: number, perPage: number) {
        const { data } = await api.get<Envelope<IraSearchHistoryTypes.Page<IraSearchHistoryTypes.SearchRow>>>(
            'ira-search-history/searches',
            { params: { page, perPage }, ...OWN_403 },
        );
        return data.result;
    },

    async getSearch(id: string) {
        const { data } = await api.get<Envelope<IraSearchHistoryTypes.SearchDetail>>(`ira-search-history/searches/${id}`, OWN_403);
        return data.result;
    },

    async listFlags(page: number, perPage: number, status?: IraSearchHistoryTypes.FlagStatus, reference?: string) {
        const { data } = await api.get<Envelope<IraSearchHistoryTypes.Page<IraSearchHistoryTypes.FlagRow>>>(
            'ira-search-history/flags',
            { params: { page, perPage, ...(status ? { status } : {}), ...(reference ? { reference } : {}) }, ...OWN_403 },
        );
        return data.result;
    },

    async createFlag(target: IraSearchHistoryTypes.FlagTarget, comment: string) {
        const { data } = await api.post<Envelope<{ id: string; reference: string; emailSent: boolean }>>(
            'ira-search-history/flags',
            { ...target, comment },
            OWN_403,
        );
        return data.result;
    },

    async resolveFlag(id: string) {
        const { data } = await api.post<Envelope<IraSearchHistoryTypes.FlagRow>>(`ira-search-history/flags/${id}/resolve`, undefined, OWN_403);
        return data.result;
    },
};
